import { ArticleParagraph1, ArticleParagraph2, useDeviceType, Image } from '@cian/ui-kit';
import * as style from './SliderItem.css';
import classNames from 'classnames';
import { openArticle } from '../tracking';

interface ISliderItemProps {
  title: string;
  notice: string;
  image: string;
  link: string;
}

export const SliderItem: React.FC<ISliderItemProps> = ({ title, notice, image, link }) => {
  const device = useDeviceType();

  return (
    <a href={link} onClick={() => openArticle(title, link)} className={style['link']} target="_blank" rel="noreferrer">
      <div className={classNames(style['container'], device === 'phone' && style['container-phone'])}>
        <div className={style['image']}>
          <Image
            preloader
            alt={title}
            objectFit="contain"
            src={`https://cdn.cian.site/frontend/info-assets/sob-guide/${image}`}
          />
        </div>
        <div className={style['title']}>
          <ArticleParagraph1 fontWeight="400">{title}</ArticleParagraph1>
        </div>
        <div className={style['notice']}>
          <ArticleParagraph2 color="gray_icons_100" fontWeight="400">
            {notice}
          </ArticleParagraph2>
        </div>
      </div>
    </a>
  );
};
